export default "__VITE_ASSET__DN6lpe6f__"